import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const SyncClientGroupsRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>SyncClientGroupsRootPage</h1>

      <LookupByUuidForm
        onSubmit={uuid =>
          navigate(atlasRoutes.syncClientGroupsView({ params: { syncClientGroupId: uuid } }).path)
        }
      />
    </div>
  );
};
